import { useEffect, useRef } from 'react';
import { useAppSceneContext } from '../SceneState/SceneState';
import { gsap } from "gsap";
import './Menu.scss';
import sendPostMessage from '../../sendPostMessage';

function Menu() {

    const { scene, setGotoScene } = useAppSceneContext();
    const menu = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (scene === "loading") {
            gsap.fromTo(menu.current, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.6
            });
        }
    }, [scene]);


    return (
        <>
            <div ref={menu} className={"gws-demo--menu " + scene}>
                <a href="#connect" className={scene === "connect" ? "active" : ""} onClick={(ev) => {
                    ev.preventDefault();
                    sendPostMessage("Google workspace demo: tabs", "Connect with your team", "in-page interaction");
                    setGotoScene(""); setTimeout(() => { setGotoScene(scene === "loading" ? "scene1OpeningAni" : "scene1Act1Ani"); }, 100);
                }}>Connect with your team</a>
                <a href="#create" className={scene === "create" ? "active" : ""} onClick={(ev) => {
                    ev.preventDefault();
                    sendPostMessage("Google workspace demo: tabs", "Create in real time", "in-page interaction");
                    setGotoScene(""); setTimeout(() => { setGotoScene("scene2OpeningAni"); }, 100)
                }}>Create in real time</a>
                <a href="#collaborate" className={scene === "collaborate" ? "active" : ""} onClick={(ev) => {
                    ev.preventDefault();
                    sendPostMessage("Google workspace demo: tabs", "Collaborate from anywhere", "in-page interaction");
                    setGotoScene(""); setTimeout(() => { setGotoScene("scene3OpeningAni"); }, 100)
                }}>Collaborate from anywhere</a>
            </div>
        </>
    )

}

export default Menu;
